//Require static assets

//Module Imports
import appState from './appState';

import * as nav from './global/nav';
import * as footer from './global/footer';
import * as components from './global/components';

import versionJson from './version.json';
import jQuery from '../lib/jquery-2.1.4.min.js';
import Chosen from '../lib/chosen.jquery.js';

import Modal from './components/Modal';
import Tooltip from './components/Tooltip';
import Loader from './components/Loader';
import ButtonSwitch from './components/ButtonSwitch';
import TextareaCountdown from './components/TextareaCountdown';
import AddressAutoComplete from './components/AddressAutoComplete';
import DatePicker from './components/DatePicker';
import Tabs from './components/Tabs';
import SortableTable from './components/SortableTable';
// import QuoteComparisonTable from './components/QuoteComparisonTable';
import ViewMoreLess from './components/ViewMoreLess';
import ToTopArrow from './components/ToTopArrow';
import ValidateForm from './components/ValidateForm';
import InPageNavigation from './components/InPageNavigation';
import TimelineFilter from './components/TimelineFilter';
import Timeline from './components/Timeline';
import Accordion from './components/Accordion';
import Alert from './components/Alert';
import MoreInfoButton from './components/MoreInfoButton';
import BackgroundPattern from './components/BackgroundPattern';
import BackgroundPatternPortfolioPage from './components/BackgroundPatternPortfolioPage';
import DotNavigation from './components/DotNavigation';
import EditableTable from './components/EditableTable';
import CoverageGraph from './components/CoverageGraph';
import CommonQuestionsSquares from './components/CommonQuestionsSquares';
import UpsellCarousel from './components/Upsell';
import Portfolio from './components/portfolio';
import PayPlans from './components/PayPlans';
import ConsolidatedSummary from './components/ConsolidatedSummary';
import EditComponent from './components/EditComponent';
import DockedMessage from './components/DockedMessage';
import SegmentedControl from './components/SegmentedControl';
import MultipleSelectBox from './components/MultipleSelectBox';
import CardSelections from './components/CardSelections';
import TimeInput from './components/TimeInput';
import NavigationalBox from './components/NavigationalBox';
import PasswordMeter from './components/PasswordMeter';
import CreditCard from './components/CreditCard';
import CurrencyInput from './components/CurrencyInput';
import MakePayment from './components/MakePayment';

let GDK = GDK || {};

//let version = versionJson.version;
//let date = Date.now().toString();
////let build = [date.slice(0, 3), ".", date.slice(3, 6), ".", date.slice(6, 10)].join().replace(/[, ]+/g, "").trim();

function init() {

	let ProtoGDK = {
		about: versionJson,
		navigation : nav,
		Modal : Modal,
		Tooltip : Tooltip,
		Loader : Loader,
		ButtonSwitch : ButtonSwitch,
		TextareaCountdown : TextareaCountdown,
		DatePicker : DatePicker,
		AddressAutoComplete	:	AddressAutoComplete,
		Tabs : Tabs,
		SortableTable : SortableTable,
		// QuoteComparisonTable : QuoteComparisonTable,
		ViewMoreLess : ViewMoreLess,
		ValidateForm : ValidateForm,
		InPageNavigation : InPageNavigation,
		TimelineFilter : TimelineFilter,
		Timeline : Timeline,
		Accordion : Accordion,
		ToTopArrow : ToTopArrow,
		Alert: Alert,
		MoreInfoButton: MoreInfoButton,
		BackgroundPattern: BackgroundPattern,
		BackgroundPatternPortfolioPage: BackgroundPatternPortfolioPage,
		DotNavigation: DotNavigation,
		EditableTable: EditableTable,
		CoverageGraph: CoverageGraph,
		CommonQuestionsSquares: CommonQuestionsSquares,
		ConsolidatedSummary: ConsolidatedSummary,
		UpsellCarousel: UpsellCarousel,
		footer: footer,
		PayPlans: PayPlans,
		jQuery: jQuery,
		Chosen: Chosen,
		MultipleSelectBox: MultipleSelectBox,
		Portfolio: Portfolio, 
		EditComponent: EditComponent,
		DockedMessage: DockedMessage,
		SegmentedControl: SegmentedControl,
		CardSelections: CardSelections,
		TimeInput: TimeInput,
		NavigationalBox: NavigationalBox,
		components: components,
		PasswordMeter: PasswordMeter,
		CurrencyInput: CurrencyInput,
		CreditCard: CreditCard,
		MakePayment: MakePayment
	};

	for(var property in ProtoGDK) {
		if(!GDK.hasOwnProperty(property)) {
			GDK[property] = ProtoGDK[property];
		}
	}

	window.addEventListener('resize', () => {
		handleResize();
	});

	handleResize();

}


function handleResize() {
	appState.windowSize = {width : window.innerWidth || document.documentElement.clientWidth, height : window.innerHeight || document.documentElement.clientHeight};
}

init();
window.GDK = GDK;
export { GDK };



// WEBPACK FOOTER //
// ./src/js/geico-design-kit/geico-design-kit.js